export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img3-6078401b97995d8c76601c03af1f7429.png";